import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { jsicMenu } from '../../../../constants/SidebarValues';

class SelectJsicDialog extends React.Component {
  render() {
    const { isOpen, toggleDialog, set, save } = this.props;

    return (
      <SelectNestedMenuDialog
        isOpen={isOpen}
        toggleDialog={toggleDialog}
        set={set}
        save={save}
        title="業界を選択"
        nestedMenu={jsicMenu}
        colCount={3}
      />
    );
  }
}

SelectJsicDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  set: PropTypes.object.isRequired,
};

export default SelectJsicDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectJsicDialog.jsx